<template>
  <g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.8958 60.9556C31.0579 60.9556 32 60.0136 32 58.8515V34.0536C32 32.8915 31.0579 31.9495 29.8958 31.9495L5.098 31.9495C3.93589 31.9495 2.99385 32.8916 2.99385 34.0536C2.99385 35.2157 3.93589 36.1578 5.098 36.1578H24.8159L0.616295 59.535C-0.205432 60.3567 -0.205432 61.689 0.616295 62.5107C1.43802 63.3324 2.77029 63.3324 3.59205 62.5107C4.41378 61.689 27.7917 39.1335 27.7917 39.1335V58.8515C27.7917 60.0136 28.7337 60.9556 29.8958 60.9556Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.1042 3.04434C32.9421 3.04434 32 3.98642 32 5.14853L32 29.9464C32 31.1084 32.9421 32.0505 34.1041 32.0505H58.902C60.0641 32.0505 61.0062 31.1084 61.0062 29.9463C61.0062 28.7843 60.0641 27.8422 58.902 27.8422H39.1841L63.3837 4.46504C64.2054 3.64331 64.2054 2.31102 63.3837 1.48929C62.562 0.667564 61.2297 0.667564 60.408 1.48929C59.5862 2.31102 36.2083 24.8664 36.2083 24.8664V5.14853C36.2083 3.98642 35.2662 3.04434 34.1042 3.04434Z"
    />
  </g>
</template>
